export default function shortestWhipLength ({spreaderTimes, whipLength, locale = 'de', isUrmP8 = false}) {
  let shortestWhipLength = 0
  if (isUrmP8)
    shortestWhipLength = shortestWhipLengthUrmP8({spreaderTimes, whipLength})
  else
    shortestWhipLength = shortestWhipLengthDefault({spreaderTimes, whipLength})

  return Intl.NumberFormat(locale, { style: 'decimal', maximumFractionDigits: 2}).format(shortestWhipLength)
}

// for non-Urm plugs stepping of whips is 5cm
function shortestWhipLengthDefault({ spreaderTimes, whipLength }) {
  switch(spreaderTimes) {
    case 2:
    case 4:
      return whipLength - .05
    case 6:
      return whipLength - .1
    case 8:
    case 16:
      return whipLength - .15
    case 12:
    case 24:
    case 32:
    case 36:
      return whipLength - .25
    case 48:
      return whipLength - .35
    case 64:
    case 72:
    case 96:
    case 128:
    case 144:
      return whipLength - .75
    default:
      return whipLength
  }
}

// URM P8 requires 7cm stepping after the first plug (hence the -1)
// also utilize 2-times stepping, so 2 plugs are on the same level
function shortestWhipLengthUrmP8({ spreaderTimes, whipLength }) {
  return whipLength - ((Math.floor((spreaderTimes - 1) / 2)) * .07)
  // 3x8 -> 1 * 7cm --> 2 "pairs", one offset
  // 16x8 -> 7 * 7cm --> 8 pairs , 7 offset
}